export const searchDefaultParameters = {
  frontend: "1",
  current: "1",
  fields: ["hotel_ratings"],
};
